// Locations mapped by regions in Ghana
export const locationsByRegion = {
  "greater-accra": [
    "Accra",
    "Tema",
    "Korle-Bu",
    "Labadi",
    "Osu",
    "Cantonments",
    "East Legon",
    "West Legon",
    "Adenta",
    "Madina",
    "Ashaiman",
    "Teshie",
    "Nungua",
    "Dansoman",
    "Kaneshie",
    "Mallam",
    "Kasoa",
    "Weija",
    "Dzorwulu",
    "Airport Residential",
    "Other",
  ],
  ashanti: [
    "Kumasi",
    "Obuasi",
    "Ejisu",
    "Konongo",
    "Mampong",
    "Offinso",
    "Bekwai",
    "Juaso",
    "Asante Mampong",
    "Ejura",
    "Agogo",
    "Kumawu",
    "Effiduase",
    "Asokore",
    "Asokwa",
    "Suame",
    "Bantama",
    "Manhyia",
    "Other",
  ],
  western: [
    "Takoradi",
    "Sekondi",
    "Tarkwa",
    "Prestea",
    "Bogoso",
    "Axim",
    "Half Assini",
    "Elubo",
    "Enchi",
    "Bibiani",
    "Sefwi Wiawso",
    "Juaboso",
    "Asankragwa",
    "Wassa Akropong",
    "Other",
  ],
  eastern: [
    "Koforidua",
    "Akosombo",
    "Nkawkaw",
    "Mpraeso",
    "Aburi",
    "Akropong",
    "Begoro",
    "Kibi",
    "Asamankese",
    "Suhum",
    "Akuapem",
    "Kwahu",
    "Fanteakwa",
    "Other",
  ],
  volta: [
    "Ho",
    "Keta",
    "Anloga",
    "Kpando",
    "Hohoe",
    "Kadjebi",
    "Krachi",
    "Nkwanta",
    "Jasikan",
    "Kpeve",
    "Sogakope",
    "Akatsi",
    "Keta",
    "Other",
  ],
  central: [
    "Cape Coast",
    "Kasoa",
    "Winneba",
    "Swedru",
    "Saltpond",
    "Mankessim",
    "Dunkwa",
    "Assin Foso",
    "Twifo Praso",
    "Abura Dunkwa",
    "Komenda",
    "Elmina",
    "Other",
  ],
  northern: [
    "Tamale",
    "Yendi",
    "Savelugu",
    "Kumbungu",
    "Tolon",
    "Nanton",
    "Saboba",
    "Chereponi",
    "Gushegu",
    "Karaga",
    "Mion",
    "Sagnerigu",
    "Other",
  ],
  "upper-east": [
    "Bolgatanga",
    "Bawku",
    "Navrongo",
    "Paga",
    "Bongo",
    "Talensi",
    "Nabdam",
    "Kassena Nankana",
    "Builsa",
    "Binduri",
    "Other",
  ],
  "upper-west": [
    "Wa",
    "Lawra",
    "Jirapa",
    "Nandom",
    "Lambussie",
    "Sissala East",
    "Sissala West",
    "Daffiama",
    "Other",
  ],
  "western-north": [
    "Sefwi Wiawso",
    "Bibiani",
    "Juaboso",
    "Bia",
    "Suaman",
    "Aowin",
    "Other",
  ],
  ahafo: ["Goaso", "Bechem", "Hwidiem", "Kenyasi", "Mim", "Other"],
  bono: ["Sunyani", "Berekum", "Dormaa", "Wenchi", "Other"],
  "bono-east": [
    "Techiman",
    "Atebubu",
    "Kintampo",
    "Nkoranza",
    "Sene",
    "Pru",
    "Other",
  ],
  oti: ["Dambai", "Kete Krachi", "Nkwanta", "Jasikan", "Kadjebi", "Other"],
  savannah: ["Damongo", "Bole", "Sawla", "Tuna", "Other"],
  "north-east": ["Nalerigu", "Gambaga", "Walewale", "Yunyoo", "Other"],
};

export default locationsByRegion;
